import { useMemo } from "react";

import { menu } from "../data/menu";

const useMenu = () => {
  const navigationMenu = useMemo(() => {
    return menu;
  }, []);

  const getMenuItem = (id) => {
    return navigationMenu.find((item) => item.id === id);
  };

  const getMegaMenu = (id) => {
    const item = getMenuItem(id);

    if (!item) {
      return null;
    }

    if (
      !item.megaMenu ||
      !item.megaMenu.sections ||
      item.megaMenu.sections.length === 0
    ) {
      return null;
    }

    return item.megaMenu;
  };

  return {
    menu: navigationMenu,

    getMenuItem,

    getMegaMenu,
  };
};

export default useMenu;
